import {Skeleton, Stack} from '@mui/material';
import React from 'react';

export function ServicePointsLoading() {
	return (
		<Stack gap={2}>
			{Array.from({length: 3}).map((_, i) => (
				<Skeleton key={i} variant="rounded" height={172} />
			))}
		</Stack>
	);
}
